import { motion } from 'framer-motion';
import { ArrowRight, XCircle, CheckCircle2, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AnimatedSection, AnimatedItem, staggerContainer } from '@/components/animations';

const beforeItems = [
  'Decisões baseadas apenas no prestador',
  'Propostas aceites sem validação',
  'Exposição a custos desnecessários',
  'Sem histórico técnico documentado',
];

const afterItems = [
  'Decisão suportada por análise independente',
  'Avaliação técnica de cada proposta',
  'Diferenciação entre obrigatório e recomendado',
  'Histórico completo e rastreável',
];

export function BeforeAfterSection() {
  return (
    <section className="py-16 md:py-24 border-t border-border bg-muted/30">
      <div className="container">
        <AnimatedSection className="max-w-5xl mx-auto" stagger>
          <AnimatedItem className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/50 text-foreground text-sm font-medium mb-6">
              <RefreshCw className="w-4 h-4" />
              O que muda quando cria conta
            </div>
            <h2 className="text-3xl md:text-4xl font-bold">
              De decisões reativas a decisões informadas
            </h2>
          </AnimatedItem>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {/* ANTES */}
            <motion.div 
              className="rounded-2xl bg-destructive/5 border border-destructive/20 p-6"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <div className="flex items-center gap-2 mb-6">
                <div className="w-8 h-8 rounded-full bg-destructive/10 flex items-center justify-center">
                  <XCircle className="w-5 h-5 text-destructive" />
                </div>
                <h3 className="text-lg font-semibold text-destructive">Antes</h3>
              </div>
              <ul className="space-y-3">
                {beforeItems.map((item, idx) => (
                  <motion.li 
                    key={idx}
                    className="flex items-start gap-3 text-sm text-foreground"
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                  >
                    <XCircle className="w-4 h-4 text-destructive shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </motion.li>
                ))}
              </ul>
            </motion.div>

            {/* DEPOIS */}
            <motion.div 
              className="rounded-2xl bg-primary/5 border border-primary/20 p-6"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <div className="flex items-center gap-2 mb-6">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                  <CheckCircle2 className="w-5 h-5 text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-primary">Depois</h3>
              </div>
              <ul className="space-y-3">
                {afterItems.map((item, idx) => (
                  <motion.li 
                    key={idx}
                    className="flex items-start gap-3 text-sm text-foreground"
                    initial={{ opacity: 0, x: 10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                  >
                    <CheckCircle2 className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          </div>

          <AnimatedItem className="text-center mt-10">
            <Button asChild size="lg" className="gap-2">
              <Link to="/members/auth">
                Criar conta gratuita
                <ArrowRight className="w-4 h-4" />
              </Link>
            </Button>
          </AnimatedItem>
        </AnimatedSection>
      </div>
    </section>
  );
}
